const isScrolledIntoView = (el) => {
  let rect = el.getBoundingClientRect();
  let offset = 200;
  let elemTop = rect.top + offset;
  let elemBottom = rect.bottom + offset;
  // Only completely visible elements return true:
  // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

// const initSectionAnimation = () => {
//   document.querySelectorAll('[theme-animation-block]').forEach((block) => {
//     if(isScrolledIntoView(block)) {
//       block.classList.add('animation-init');
//     }
//   })
//   document.querySelectorAll("[theme-animation-fade]").forEach((block) => {
//     if (isScrolledIntoView(block)) {
//       block.classList.add("animation-fade-init");
//     }
//   });
// }

// window.addEventListener('DOMContentLoaded', () => {
//   initSectionAnimation();
// })

// window.addEventListener('scroll', () => {
//   initSectionAnimation();
// })

window.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll("[theme-animation-block] em");
  items.forEach((el, i) => {
    i=i+1;
    setTimeout(() => {
      el.classList.add("animation-init");
    }, i * 500);
  });
  document.querySelectorAll('em').forEach(el => {
    el.setAttribute('data-text', el.textContent);
  });
});


// document.addEventListener('DOMContentLoaded', function() {
  
//   var mouseX = 0, mouseY = 0;
//   var xp = 0, yp = 0;
   
//   document.addEventListener('mousemove', function(e) {
//     mouseX = e.pageX;
//     mouseY = e.pageY; 
//   });
  
//   setInterval(function() {
//     xp += ((mouseX - xp)/6);
//     yp += ((mouseY - yp)/6);
//     var circle = document.querySelector('.blur-effect');
//     if(circle) {
//       circle.style.left = (xp - circle.offsetWidth/2) + 'px';
//       circle.style.top = (yp - circle.offsetHeight/2) + 'px';
//     }
//   }, 20);

// });

document.addEventListener('DOMContentLoaded', function() {
  const blur = document.querySelector(".blur-effect");

  if (blur) {
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const offset = 30;
    const initialDelay = 2000; // 3 seconds delay
    let isActive = false;

    // Hide blur effect initially
    blur.style.opacity = '0';

    // Activate blur effect after delay
    setTimeout(function() {
      isActive = true;
      blur.style.opacity = '1';
    }, initialDelay);

    document.addEventListener("mousemove", function(e) {
      targetX = e.clientX - offset;
      targetY = e.clientY - offset;

      // Initialize position on first move after activation
      if (isActive && currentX === 0 && currentY === 0) {
        currentX = e.clientX - offset;
        currentY = e.clientY - offset;
      }
    });

    function animate() {
      if (isActive) {
        currentX += (targetX - currentX) * 0.15;
        currentY += (targetY - currentY) * 0.15;

        blur.style.left = `${currentX}px`;
        blur.style.top = `${currentY}px`;
      }

      requestAnimationFrame(animate);
    }

    animate();
  }

  // var rf_mouse = {
  //   x: 0,
  //   y: 0
  // };

  // var rf_lines = [];
  // var requestId = null;

  // function initSpinners() {
  //   var spinners = document.querySelectorAll('.is-spinner');
  //   rf_lines = [];
  //   spinners.forEach(function(spinner) {
  //     var rect = spinner.getBoundingClientRect();
  //     rf_lines.push({
  //       element: spinner,
  //       cx: rect.left + rect.width / 2,
  //       cy: rect.top + rect.height / 2
  //     });
  //   });
  // }

  // window.addEventListener("mousemove", function(event) {
  //   rf_mouse.x = event.pageX;
  //   rf_mouse.y = event.pageY;

  //   if (!requestId) {
  //     requestId = requestAnimationFrame(rf_spinner_update);
  //   }
  // });

  // function rf_spinner_update() {
  //   for (var i = 0; i < rf_lines.length; i++) {
  //     var line = rf_lines[i];
  //     var targetAngle = Math.atan2(rf_mouse.y - line.cy, rf_mouse.x - line.cx);

  //     // Get current rotation or initialize if not set
  //     if (!line.currentAngle) {
  //       line.currentAngle = targetAngle;
  //     }

  //     // Calculate the shortest path between angles
  //     var diff = targetAngle - line.currentAngle;
  //     while (diff > Math.PI) diff -= 2 * Math.PI;
  //     while (diff < -Math.PI) diff += 2 * Math.PI;

  //     // Apply smooth interpolation (adjust 0.1 for faster/slower animation)
  //     line.currentAngle += diff * 0.1;
  //     var transform = "rotate(" + line.currentAngle + "rad)";

  //     if (line.element.classList.contains('animate-image')) {
  //       line.element.querySelector('img').style.transform = transform;
  //       line.element.querySelector('img').style.transition = 'transform 0.1s ease-out';
  //     } else {
  //       line.element.style.transform = transform;
  //       line.element.style.transition = 'transform 0.1s ease-out';
  //     }
  //   }
  //   requestId = null;
  // }

  // initSpinners();

  var rf_mouse = {
    x: 0,
    y: 0
  };

  var rf_lines = [];
  var requestId = null;

  function initSpinners() {
    var spinners = document.querySelectorAll('.is-spinner');
    rf_lines = [];
    
    spinners.forEach(function(spinner) {
      var rect = spinner.getBoundingClientRect();
      var isHalfSpinning = spinner.classList.contains('half-spinning');
      
      rf_lines.push({
        element: spinner,
        cx: rect.left + rect.width / 2 + window.scrollX,
        cy: rect.top + rect.height / 2 + window.scrollY,
        currentAngle: isHalfSpinning ? 0 : undefined,
        isHalfSpinning: isHalfSpinning
      });
    });
  }

  window.addEventListener("mousemove", function(event) {
    rf_mouse.x = event.pageX;
    rf_mouse.y = event.pageY;

    if (!requestId) {
      requestId = requestAnimationFrame(rf_spinner_update);
    }
  });

  // Add resize listener to recalculate positions
  window.addEventListener('resize', function() {
    initSpinners();
  });

  function rf_spinner_update() {
    for (var i = 0; i < rf_lines.length; i++) {
      var line = rf_lines[i];
      var rawTargetAngle = Math.atan2(rf_mouse.y - line.cy, rf_mouse.x - line.cx);
      var targetAngle;

      // Handle half-spinning elements
      if (line.isHalfSpinning) {
        // Normalize angle to -π to π range
        var constrainedAngle = rawTargetAngle;
        while (constrainedAngle > Math.PI) constrainedAngle -= 2 * Math.PI;
        while (constrainedAngle < -Math.PI) constrainedAngle += 2 * Math.PI;
        
        // Constrain to -20° to +90° range
        var minAngle = -Math.PI / 9; // -20 degrees
        var maxAngle = Math.PI / 2;  // +90 degrees
        
        if (constrainedAngle < minAngle) {
          targetAngle = minAngle;
        } else if (constrainedAngle > maxAngle) {
          targetAngle = maxAngle;
        } else {
          targetAngle = constrainedAngle;
        }
      } else {
        targetAngle = rawTargetAngle;
      }

      // Initialize current angle if not set
      if (!line.currentAngle && line.currentAngle !== 0) {
        line.currentAngle = targetAngle;
      }

      // Calculate difference
      var diff;
      if (line.isHalfSpinning) {
        // For half-spinning, simple difference
        diff = targetAngle - line.currentAngle;
      } else {
        // For full rotation, shortest path
        diff = targetAngle - line.currentAngle;
        while (diff > Math.PI) diff -= 2 * Math.PI;
        while (diff < -Math.PI) diff += 2 * Math.PI;
      }

      // Apply smooth interpolation
      line.currentAngle += diff * 0.1;
      
      var transform = "rotate(" + line.currentAngle + "rad)";

      // Apply transform with error handling
      if (line.element.classList.contains('animate-image')) {
        var img = line.element.querySelector('img');
        if (img) {
          img.style.transform = transform;
        }
      } else {
        line.element.style.transform = transform;
      }
    }
    
    requestId = null;
  }

  // Method to refresh spinners
  function refreshSpinners() {
    initSpinners();
  }

  // Initialize spinners
  initSpinners();
});

window.addEventListener("load",function(){
  // Intersection Observer for reveal animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
            }
        });
    }, observerOptions);

    // Observe all reveal sections
    const allSections = document.querySelectorAll('.shopify-section:not(.vertical-slider-text-section)');
    if(allSections.length){
      allSections.forEach(section => {
          observer.observe(section);
      });
    }
})

window.addEventListener("load",function(){
  const observerOptions = {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              triggerAnimation();
          }
      });
  }, observerOptions);

  // Observe the animated section
  const animatedSection = document.querySelector('.mount-rich-text-about');
  observer.observe(animatedSection);

  function triggerAnimation() {
      // First: Animate center text
      const centerText = document.querySelector('.custom-text-with-icons .section-heading__text');
      centerText?.classList.add('animate');

      const centerText2 = document.querySelector('.custom-text-with-icons .pre_heading ');
      centerText2?.classList.add('animate');

      // Second: Animate corner shapes using forEach with staggered timing
      const cornerShapes = document.querySelectorAll('.custom-text-with-icons__icons-wrapper .custom-text--icon');
      if(cornerShapes.length){
        cornerShapes.forEach((shape, index) => {
            setTimeout(() => {
                shape.classList.add('animate');
            }, 600 + (index * 300)); // Start at 600ms, then 200ms between each shape
        });
      }
  }
})